import React, { useEffect, useMemo } from 'react'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { IAddSellerRequest, IAuthSellerBrand, IAuthSellerData, IAuthSellerDealerData, IAuthSellerRequest, IChangeStatusRequest } from '../models/models'
import { useCustomReducer } from '../../../../../base/customHooks'
import Table from '../../../../../components/Table'
import IPButton from '../../../../../components/IPButtonSearch'
import { ListAuthSellerDataApi } from '../services/ListAuthSellerDataApi'
import moment from 'moment'
import IPInput from '../../../../../components/IPInput'
import IPSelectBox from '../../../../../components/IPSelectBox'
import { ISelectOption } from '../../../../../components/IPSelectBox/IPSelectBox'
import { ListAuthSellerDealerApi } from '../services/ListAuthSellerDealerApi'
import { ChangeStatusApi } from '../services/ChangeStatusApi'
import { AddDealerApi } from '../services/AddDealerApi'
import { GetAuthSellerBrandsApi } from '../services/getAuthSellerBrandsApi'

interface IListDppAndMicrosoftState {
  authSellerData: IAuthSellerData[]
  authDealerData: IAuthSellerDealerData[]
  authBrandData: IAuthSellerBrand[]
  dealerCode?: string
  fileStatus?: ISelectOption
  dealerStatus?: ISelectOption
  marketPlace?: ISelectOption
  newDealerCode?: string
  newBrand?: ISelectOption
  newStatus?: number
}

function AuthMicrosoftSellers(props: BaseComponentWithContextProps) {

  const getInitialState = (): IListDppAndMicrosoftState => {
    return {
      authSellerData: [],
      authBrandData: [],
      authDealerData: [],
    }
  }

  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<IListDppAndMicrosoftState>(intialState)

  const getDppAndMicrosoftPageList = async () => {
    const req: IAuthSellerRequest = {
      DealerCode: state.dealerCode,
      FileStatus: state.fileStatus && Number(state.fileStatus?.value),
      DealerStatus: state.dealerStatus && Number(state.dealerStatus?.value),
      MarketPlace: state.marketPlace?.value?.toString()
    }
    props.showLoading();
    const listDppManagementPageDataApi: ListAuthSellerDataApi = new ListAuthSellerDataApi({})
    listDppManagementPageDataApi
      .ListAuthSellerData(req)
      .then((res: any) => {
        setState({ authSellerData: res })
        props.hideLoading();
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading();
      })
  }

  useEffect(() => {
    getBrandList()
    getDealerList()
    getDppAndMicrosoftPageList()
  }, [])

  const getDealerList = async () => {
    const dealerApi: ListAuthSellerDealerApi = new ListAuthSellerDealerApi({})
    dealerApi
      .ListAuthSellerData()
      .then((res: any) => {
        setState({ authDealerData: res })
        props.hideLoading();
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      })
  }

  const getBrandList = async () => {
    const brandApi: GetAuthSellerBrandsApi = new GetAuthSellerBrandsApi({})
    brandApi
      .GetBrands()
      .then((res: any) => {
        setState({ authBrandData: res })
        props.hideLoading();
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      })
  }

  const addDealer = async () => {

    if (state.newBrand?.value === undefined || state.newBrand?.value === null || state.newBrand?.value === "") {
      Swal.fire({
        icon: 'error',
        title: "Lütfen marka seçiniz.",
        showConfirmButton: true,
        allowOutsideClick: false,
      })
      return;
    }

    if (state.newDealerCode === undefined || state.newDealerCode === null || state.newDealerCode === "") {
      Swal.fire({
        icon: 'error',
        title: "Lütfen bayi kodu giriniz.",
        showConfirmButton: true,
        allowOutsideClick: false,
      })
      return;
    }

    const req: IAddSellerRequest = {
      DealerCode: state.newDealerCode,
      BrandId: Number(state.newBrand.value),
      Status: 1
    }
    props.showLoading();
    const addDealerApi: AddDealerApi = new AddDealerApi({})
    addDealerApi
      .AddDealer(req)
      .then((res: any) => {
        Swal.fire({
          icon: 'success',
          title: res === true ? "Başarılı bir şekilde kaydedilmiştir." : "İşlem tamamlanırken bir hata meydana geldi.",
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading();
        getDppAndMicrosoftPageList()
        getDealerList()
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading();
      })
  }

  const changeStatus = async (id: number, type: string, name: string, market?: string, status?: number) => {
    let message = ""
    if (type === "File") {
      message = name + " bayisine ait " + market + " pazar yeri belgesini iptal etmek"
    }
    else if (type === "Block") {
      if (status === -1)
        message = name + " bayisinin engelini kaldırmak"
      else if (status != -1)
        message = name + " bayisini yasaklamak"
    }
    else if (type === "Active") {
      if (status === 1)
        message = name + " bayisini pasife çekmek"
      else if (status != 1)
        message = name + " bayisini aktifleştirmek"

    }

    Swal.fire({
      icon: 'question',
      title: `${message} istediğinize emin misiniz?`,
      showConfirmButton: true,
      allowOutsideClick: false,
      showDenyButton: true,
      confirmButtonText: 'Evet',
      denyButtonText: 'Hayır',
    }).then(async result => {
      if (result.isConfirmed) {
        const req: IChangeStatusRequest = {
          Type: type,
          Id: id
        }
        props.showLoading();
        const changeStatusApi: ChangeStatusApi = new ChangeStatusApi({})
        changeStatusApi
          .ChangeStatus(req)
          .then((res: any) => {
            Swal.fire({
              icon: 'success',
              title: res === true ? "Başarılı bir şekilde kaydedilmiştir." : "İşlem tamamlanırken bir hata meydana geldi.",
              showConfirmButton: true,
              allowOutsideClick: false,
            })
            props.hideLoading();
            getDppAndMicrosoftPageList()
            getDealerList()
          })
          .catch(err => {
            Swal.fire({
              icon: 'error',
              title: err.description,
              showConfirmButton: true,
              allowOutsideClick: false,
            })
            props.hideLoading();
          })
      }
    })
  }

  const tableColumnsDealer = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'col1',
      },
      {
        Header: 'Bayi Kodu',
        accessor: 'col2',
      },
      {
        Header: 'Bayi Adı',
        accessor: 'col3',
      },
      {
        Header: 'Marka',
        accessor: 'brand',
      },
      {
        Header: 'Durum',
        accessor: 'col4',
      },
      {
        Header: 'İşlemler',
        accessor: 'col5',
      },
    ],
    []
  )

  const tableDataDealer = useMemo(
    () =>
      state.authDealerData.map((item, index) => {
        const data = {
          col1: index + 1,
          col2: item.DealerCode?.replace("0000", ""),
          brand: item.BrandName,
          col3: item.DealerName,
          col4: item.Status === 1 ? "Aktif" :
            item.Status === 0 ? "Pasif" :
              item.Status === -1 ? "Engellenmiş Bayi" : "",
          col5: (
            <>
              {item.Status != -1 &&
                <a
                  data-action-type='edit'
                  role='button'
                  style={{ cursor: 'pointer' }}
                  data-toggle='tooltip'
                  onClick={() => {
                    changeStatus(item.Id, "Active", item.DealerName, '', item.Status)
                  }}
                >
                  <i className='icon-refresh-ccw' style={{ fontSize: '1.2rem', color: item.Status === 1 ? 'orange' : item.Status === 0 ? 'green' : '' }}></i>
                </a>
              }
              <a
                data-action-type='delete'
                role='button'
                style={{ cursor: 'pointer' }}
                data-toggle='tooltip'
                onClick={() => {
                  changeStatus(item.Id, "Block", item.DealerName, '', item.Status)
                }}
              >
                {item.Status != -1 ? (<i className='icon-lock' style={{ fontSize: '1.2rem', color: 'red' }}></i>) :
                  item.Status === -1 ? (<i className='icon-unlock' style={{ fontSize: '1.2rem', color: 'green' }}></i>) : (<></>)}
              </a>
            </>
          )
        }
        return data
      }),
    [state.authDealerData]
  )


  const tableColumns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'col1',
      },
      {
        Header: 'Bayi Kodu',
        accessor: 'col2',
      },
      {
        Header: 'Bayi Adı',
        accessor: 'col3',
      },
      {
        Header: 'Market Yeri',
        accessor: 'col4',
      },
      {
        Header: 'Marka',
        accessor: 'brand',
      },
      {
        Header: 'Oluşturma Tarihi',
        accessor: 'col5',
      },
      {
        Header: 'Geçerlilik Tarihi',
        accessor: 'col6',
      },
      {
        Header: 'Durum',
        accessor: 'col7',
      },
      {
        Header: 'İşlemler',
        accessor: 'col8',
      },
    ],
    []
  )

  const tableData = useMemo(
    () =>
      state.authSellerData.map((item, index) => {
        const data = {
          col1: index + 1,
          col2: item.DealerCode?.replace("0000", ""),
          brand: item.BrandName,
          col3: item.DealerName,
          col4: <Link to={`${item.FileUrl}`} target='_blank'>{item.MarketPlace}</Link>,
          col5: item.CreatedDate && moment(item.CreatedDate).format('DD.MM.YYYY HH:mm:ss'),
          col6: item.ExpireDate && moment(item.ExpireDate).format('DD.MM.YYYY HH:mm:ss'),
          col7: (item.FileStatus === 1 && item.DealerStatus === 1) ? "Aktif" : (item.FileStatus === null && item.DealerStatus === 1) ? "Aktif Bayi" :
            item.DealerStatus === -1 ? "Engellenmiş Bayi" : item.DealerStatus === 0 ? "Pasif Bayi"
              : "Pasif",
          col8: (
            <>
              <a
                data-action-type='edit'
                role='button'
                style={{ cursor: 'pointer' }}
                data-toggle='tooltip'
                onClick={() => {
                  changeStatus(item.FileId, "File", item.DealerName, item.MarketPlace)
                }}
              >
                <i className='icon-trash-2' style={{ fontSize: '1.2rem', color: 'red' }}></i>
              </a>
            </>
          )
        }
        return data
      }),
    [state.authSellerData]
  )


  return (
    <div className='container'>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between'>
            <span className='h4'>Microsoft Yetkili Satıcıları</span>
          </div>
          <div className='card-body'>
            <div className='row'>
              <div className='col-md-3'>
                <IPInput
                  type="text"
                  placeholder="Bayi Kodu"
                  className="form-control"
                  aria-label="Search"
                  id='newDealerCode'
                  value={state.newDealerCode}
                  onChange={(e) => setState({ newDealerCode: e.target.value })}
                />
              </div>
              <div className='col-md-3'>
                <IPSelectBox
                  isClearable
                  placeholder="Marka"
                  id='brand'
                  value={state.newBrand}
                  options={state.authBrandData.map((brand) => ({
                    label: brand.Brand,
                    value: brand.Id
                  }))}
                  onChangeSingle={(option) => setState({ newBrand: option })}
                />
              </div>
              <div className='col-md-2'>
                <IPButton text="Ekle" onClick={() => {
                  addDealer()
                }}></IPButton>
              </div>
            </div>
          </div>
          <div className='card-body'>
            <b>BAYİLER</b><br></br>
            <Table columns={tableColumnsDealer} data={tableDataDealer} currentPage={0} />
          </div>
          <hr></hr>
          <div className='card-body'>
            <div className='row'>
              <div className='col-md-3'>
                <IPInput
                  type="text"
                  placeholder="Bayi Kodu"
                  className="form-control"
                  aria-label="Search"
                  id='dealerCode'
                  value={state.dealerCode}
                  onChange={(e) => setState({ dealerCode: e.target.value })}
                />
              </div>
              <div className='col-md-3'>
                <IPSelectBox
                  isClearable
                  id='MarketPlace'
                  name='MarketPlace'
                  placeholder='Pazar Yeri'
                  options={[
                    { label: 'Trendyol', value: "Trendyol" },
                    { label: 'Hepsiburada', value: "Hepsiburada" },
                  ]}
                  value={state.marketPlace}
                  onChangeSingle={(option) => setState({ marketPlace: option })}
                />
              </div>
              <div className='col-md-2'>
                <IPSelectBox
                  isClearable
                  id='FileStatus'
                  name='FileStatus'
                  placeholder='Dosya Durumu'
                  options={[
                    { label: 'Aktif', value: 1 },
                    { label: 'Pasif', value: 0 },
                  ]}
                  value={state.fileStatus}
                  onChangeSingle={(option) => setState({ fileStatus: option })}
                />
              </div>
              <div className='col-md-2'>
                <IPSelectBox
                  isClearable
                  id='DealerStatus'
                  name='DealerStatus'
                  placeholder='Bayi Durumu'
                  options={[
                    { label: 'Aktif', value: 1 },
                    { label: 'Pasif', value: 0 },
                  ]}
                  value={state.dealerStatus}
                  onChangeSingle={(option) => setState({ dealerStatus: option })}
                />
              </div>
              <div className='col-md-2'>
                <IPButton text="Süz" onClick={() => {
                  getDppAndMicrosoftPageList()
                }}></IPButton>
              </div>
            </div>
          </div>
          <div className='card-body'>
            <b>BELGELER</b><br></br>
            <Table columns={tableColumns} data={tableData} currentPage={0} />
          </div>
        </div>
      </div>
    </div >
  )
}
export default componentWithContext(AuthMicrosoftSellers)